/**
 * Calcula o azimute (bearing) inicial de um ponto GPS para outro.
 * @param {number} lat1 Latitude do ponto de partida.
 * @param {number} lon1 Longitude do ponto de partida.
 * @param {number} lat2 Latitude do ponto de destino.
 * @param {number} lon2 Longitude do ponto de destino.
 * @returns {number} O azimute em radianos.
 */
export const calculateBearing = (lat1, lon1, lat2, lon2) => {
  const toRadians = deg => deg * (Math.PI / 180);
  const lat1Rad = toRadians(lat1);
  const lon1Rad = toRadians(lon1);
  const lat2Rad = toRadians(lat2);
  const lon2Rad = toRadians(lon2);

  const deltaLon = lon2Rad - lon1Rad;

  const y = Math.sin(deltaLon) * Math.cos(lat2Rad);
  const x =
    Math.cos(lat1Rad) * Math.sin(lat2Rad) -
    Math.sin(lat1Rad) * Math.cos(lat2Rad) * Math.cos(deltaLon);

  let bearing = Math.atan2(y, x);

  if (bearing < 0) {
    bearing += 2 * Math.PI;
  }

  return bearing;
};
